















































































































































































































































































































































































































import Vue from 'vue'
import { Store } from 'vuex'
import VueRouter from 'vue-router'
import {
    createComponent,
    onMounted,
    onBeforeUnmount,
    reactive,
    ref,
    Ref,
    watch,
    computed,
    SetupContext,
    onUnmounted,
} from '@vue/composition-api'
import { UnwrapRef } from '@vue/composition-api/dist/reactivity'
import RightContextMenu from '../components/RightContextMenu.vue'
import ImgPreview from '../components/imgPreview/index.vue'
import PermissionDialog from '../components/Permission.vue'
import CopyMoveBox from '../components/CopyMoveBox.vue'
import SliceUploader from '../components/SliceUploader.vue'
import UnZipList from '../components/UnZipList.vue'
import ZipList from '../components/ZipList.vue'
import permissionEdit from '@/components/permissionEdit.vue'
import permissionGrant from '@/components/permissionGrant.vue'

import {
    getFileIcon,
    isImage,
    formatFileSize,
    preTransferHandler,
    electronDownload,
    getDesktopUrl,
} from '../helpers/common'
import { Message, Table, Input, MessageBox } from 'element-ui'
import {
    IFileItem,
    FilePermission,
    batchDeleteFileOrDir,
    mkdir,
    DragState,
    getZipDetail,
    getDirStats,
    ZipDetail,
    DirStats,
    checkBeforeDownload,
} from '@/service/public'
import { BreadcrumbItem } from '../store/public'

import { useStore, useRouter, IPageNation } from '@/hooks/common'
import { compressPrompt } from '@/hooks/rightContextMenu'
import moment from 'moment'
import isElectron from 'is-electron'
import { transferThreshold, FilePower } from '@/constant'
import { dragUploadHandler, desktopUploadHandler } from '@/service/allUse'
import DuplicateNameConfirm, { StartCheckType } from '@/components/DuplicateNameConfirm.vue'
import { findIsManager } from '@/helpers/common'
import { isEmpty } from 'lodash'

interface ImgPreviewType {
    resize: (imgInfo: IFileItem) => void
    closeFildTree: () => void
}
interface CheckBoxType {
    startCheck: (obj: StartCheckType) => {}
}
const inElectron = isElectron()
function handleCheckFile({ emit }) {
    const checkRef = ref<CheckBoxType>(void null)
    const isShowCheckBox = ref(false)
    const boxType = ref<'move' | 'copy'>('')
    const moveFile = async (params: StartCheckType) => {
        isShowCheckBox.value = true
        boxType.value = 'move'
        // 轮询弹窗处理重名文件逻辑此版本改为批量确认改名
        checkRef.value.startCheck(params)
    }
    const copyFile = async (params: StartCheckType) => {
        isShowCheckBox.value = true
        boxType.value = 'copy'
        // 轮询弹窗处理重名文件逻辑此版本改为批量确认改名
        checkRef.value.startCheck(params)
    }
    return {
        checkRef,
        isShowCheckBox,
        boxType,
        moveFile,
        copyFile,
    }
}
interface FoldDetail extends ZipDetail {
    isFold: boolean
}

function useZipDetails(store: Store<any>) {
    const isShowZipDetails = ref(false)
    const zipDetail = ref<ZipDetail>({})
    const dirStats = ref<DirStats>({})
    const zipCreatInfo = ref<{ createUserName: string | undefined; createTime: string }>({
        createUserName: '-',
        createTime: '-',
    })
    const foldDetail = ref<FoldDetail>({ isFold: false })
    watch(
        () => store.state.publicStore.dialogZipDetailsVisible,
        async val => {
            isShowZipDetails.value = false
            const currentData = store.state.publicStore.tableRowData as IFileItem
            zipCreatInfo.value.createUserName = currentData.createUserName
            zipCreatInfo.value.createTime = moment(currentData.createTime).format('YYYY-MM-DD HH:mm:ss')
            if (!currentData.isFile) {
                foldDetail.value.isFold = true
                const res = await getDirStats(currentData.id as string)
                if (res && res.code === 0 && res.data) {
                    dirStats.value = res.data
                    isShowZipDetails.value = true
                } else {
                    dirStats.value = {
                        dirNum: 0,
                        fileNum: 0,
                        totalSize: 0,
                        typeAndNum: {},
                    }
                }
            } else {
                foldDetail.value.isFold = false
                const res = await getZipDetail(currentData.id as string)
                if (res && res.code === 0 && res.data) {
                    zipDetail.value = res.data
                    isShowZipDetails.value = true
                } else {
                    zipDetail.value = {
                        dirNum: 0,
                        fileNum: 0,
                        totalOriginal: 0,
                        typeAndNum: {},
                    }
                    if (res && res.code === 0) {
                        Message.warning(res.desc)
                    } else {
                        Message.error(res.desc || '查询信息失败，请稍后重试')
                    }
                }
            }
        },
        {
            lazy: true,
        }
    )
    const closeZipDetailsDialog = () => {
        isShowZipDetails.value = false
    }
    const formatZipDetail = (data: { [key: string]: any }): string => {
        if (!data) {
            return ''
        }
        let strArr: string[] = []
        Object.keys(data).forEach(key => {
            strArr.push(`${key} (${data[key]})`)
        })
        return strArr.join('、')
    }
    return {
        foldDetail,
        zipDetail,
        dirStats,
        zipCreatInfo,
        formatZipDetail,
        isShowZipDetails,
        closeZipDetailsDialog,
    }
}
function handleDragDrop(
    store: Store<any>,
    isDisabledDownloadButton: Ref<boolean>,
    isDisabledUploadButton: Ref<boolean>,
    Uploader: Ref<Vue | null>,
    router: VueRouter,
    fromBread: Ref<boolean>,
    selectFiles: Ref<IFileItem[]>,
    setupContext: SetupContext,
    useHandleCheckFile
) {
    const isMove = ref<DragState>(DragState.DEFAULT)
    const checkPower = (param: { type: 'src' | 'dist'; dist?: IFileItem; src?: IFileItem }) => {
        // 权限
        const { src, dist, type } = param
        let moveDisable = true
        if (!src && !dist) {
            return true
        }
        if (type === 'dist' && dist && dist.isFile) {
            return true
        }
        const parentDirMove = {
            src: isDisabledDownloadButton.value,
            dist: isDisabledUploadButton.value,
        }
        const permissionCode: { [key: string]: number } = {
            src: FilePermission.DOWNLOAD,
            dist: FilePermission.UPLOAD,
        }
        const moveItem = type === 'src' ? src : dist
        if (!moveItem) {
            return true
        }
        if (moveItem.powers && Array.isArray(moveItem.powers)) {
            // 下载code为2
            moveDisable = !moveItem.powers.includes(permissionCode[type])
        } else {
            if (type === 'dist') {
                moveDisable = true
            } else {
                moveDisable = parentDirMove[type]
            }
        }

        return moveDisable
    }
    const setDragData = (e, file: IFileItem) => {
        isMove.value = DragState.MOVE
        const moveDisable = checkPower({ type: 'src', src: file })
        if (moveDisable === false) {
            e.dataTransfer.effectAllowed = 'move'
        }
        try {
            const fileData = JSON.stringify(file)
            const fileList = JSON.stringify(selectFiles.value.length ? selectFiles.value : [file])
            e.dataTransfer.setData('fileId', file.id)
            e.dataTransfer.setData('fileData', fileData)
            e.dataTransfer.setData('fileList', fileList)
            e.dataTransfer.setData('fileType', 'list')
        } catch (e) {
            console.error(e)
        }
    }
    const isDraggable = (item: IFileItem) => {
        return (
            !selectFiles.value.length ||
            (selectFiles.value.length && selectFiles.value.find(file => file.id === item.id))
        )
    }
    const handleDrop = async (e: DragEvent, target: IFileItem) => {
        const dataTransfer = e.dataTransfer ? e.dataTransfer : null
        if (!dataTransfer) {
            return
        }
        const fileType = dataTransfer.getData('fileType')
        if (fileType !== 'list') {
            return // 拖拽上传文件
        }
        e.stopPropagation()

        const list = JSON.parse(dataTransfer.getData('fileList')) as IFileItem[]
        const currentDirId = setupContext.root.$route.query.id as string
        if (currentDirId === target.id) {
            Message.error('目标文件夹不能是当前文件夹')
            return false
        }
        useHandleCheckFile.moveFile({
            list,
            currentDirId,
            target,
        })
    }
    const checkDrag = e => {
        if (e.target.className === 'fileName fileDir' || e.target.className === 'dirNameSpan') {
            e.preventDefault()
        }
        e.dataTransfer.effectAllowed = 'none'
    }
    const dragOverListener = e => {
        if (router.currentRoute.name !== 'public'  || e.dataTransfer.effectAllowed !== 'move') {
            return
        }
        e.preventDefault()
        // todo节流
        if (isMove.value !== DragState.MOVE) {
            isMove.value = DragState.UPLOAD
        }
    }
    const dragLeaveListener = e => {
        if (router.currentRoute.name !== 'public' || e.dataTransfer.effectAllowed !== 'move') {
            return
        }
        //拖离 todo节流
        if (e.screenX === 0 && e.screenY === 0) {
            isMove.value = DragState.DEFAULT
        }
        e.preventDefault()
    }
    const dropListener = (e: DragEvent) => {
        if (router.currentRoute.name !== 'public') {
            return
        }
        //@ts-ignore
        e.preventDefault()
        // 更新dirId
        const currentDirId = store.state.publicStore.currentDirId

        store.commit('publicStore/SET_UPLOAD_DIR_ID', currentDirId)
        if (
            e.dataTransfer &&
            e.dataTransfer.getData('fileType') !== 'list' &&
            !e.dataTransfer.getData('fileList') &&
            e.dataTransfer.files &&
            e.dataTransfer.files.length > 0 &&
            isMove.value === DragState.UPLOAD &&
            !isDisabledUploadButton.value
        ) {
            // upload
            const files: FileList = e.dataTransfer.files //类数组不支持map
            // eslint-disable-next-line no-useless-escape
            const reg = /\.[^\.]+$/ //通过扩展名判断
            if (inElectron) {
                const filePath = []
                for (let file of files) {
                    //@ts-ignore
                    if (file.path && reg.test(file.name)) {
                        //@ts-ignore
                        filePath.push(file.path)
                    } else {
                        Message.error('不支持文件夹上传！')
                    }
                }
                if (!filePath.length) {
                    isMove.value = isMove.value === DragState.UPLOAD ? DragState.DEFAULT : isMove.value
                    return
                }
                dragUploadHandler(currentDirId, filePath)
            } else {
                let excludeDir: File[] = [] // 数组
                for (let file of files) {
                    excludeDir.push(file)
                }
                if (!excludeDir.length) {
                    isMove.value = isMove.value === DragState.UPLOAD ? DragState.DEFAULT : isMove.value
                    return
                }

                store.commit('operateStore/SET_DRAGUPLOAD_DATA', excludeDir)
            }
            isMove.value = DragState.DEFAULT
        }
    }

    onMounted(() => {
        document.addEventListener('dragover', dragOverListener)
        document.addEventListener('dragleave', dragLeaveListener)
        document.addEventListener('drop', dropListener)
    })
    onBeforeUnmount(() => {
        document.removeEventListener('dragover', dragOverListener)
        document.removeEventListener('dragleave', dragLeaveListener)
        document.removeEventListener('drop', dropListener)
    })

    return {
        setDragData,
        isDraggable,
        handleDrop,
        checkDrag,
        checkPower,
        isMove,
        dragUploadHandler,
    }
}
function useBread(store: Store<any>, router: VueRouter, fromBread: Ref<boolean>, setupContext: SetupContext) {
    const breadData = computed(() => store.state.publicStore.breadcrumbData)
    const clickBread = async (bread: BreadcrumbItem) => {
        // 检查是否是当前路径
        if (bread.id === setupContext.root.$route.query.id + '') {
            return
        }
        // 点击面包屑导航时清除查询名称
        store.commit('publicStore/SET_QUERY_FORM_FILENAME', '')
        store.commit('publicStore/SET_CURRENT_DIR_ID', bread.id)
        store.commit('publicStore/UPDATE_TABLE_DATA_CACHE')
        const isChangeRoute = await store.dispatch('publicStore/getTableData', {
            updataType: 'init',
        })
        fromBread.value = true
        router.push({
            path: bread.path,
            query: { id: bread.id },
        })
    }
    return {
        breadData,
        clickBread,
    }
}
function setBreadData(sourcePath: IFileItem[], store: Store<any>) {
    const pathNames = sourcePath.map((item: IFileItem) => {
        return item.name
    })
    const tmpPath = sourcePath.map((item: IFileItem, index: number) => {
        const currentPath = '/public/' + pathNames.slice(0, index + 1).join('/')
        return {
            id: item.id,
            name: item.name,
            path: currentPath,
        }
    })
    const bread = [
        // 默认值，根路径
        ...tmpPath,
    ]
    store.commit('publicStore/SET_BREADCRUMB_DATA_ALL', bread)
}
function searchFrom(store: Store<any>) {
    const queryFormFileName = computed({
        get: () => store.state.publicStore.queryForm.fileName,
        set: val => {
            store.commit('publicStore/SET_QUERY_FORM_FILENAME', val)
        },
    })
    const queryFormFileTime = computed({
        get: () => store.state.publicStore.queryForm.createTime,
        set: val => {
            store.commit('publicStore/SET_QUERY_FORM_CREATETIME', val)
        },
    })
    const onSearchSubmit = (event: Event) => {
        event.preventDefault()
        // 搜索查询，需要先把页码置为1，避免没有数据但查询的页码为1以上报错

        store.commit('publicStore/SET_CURRENT_PAGE', 1)
        // fromBread.value = true;
        store.dispatch('publicStore/getTableData')
    }
    return {
        queryFormFileName,
        queryFormFileTime,
        onSearchSubmit,
    }
}

function operationButtons(store: Store<any>, router: VueRouter) {
    // 当前目录的权限
    const currentDirPermissions = computed(() => store.state.publicStore.powers || [])
    // 选中数据的权限
    const currentTableRowDataPermissions = computed(() => {
        // if (store.state.publicStore.tableRowData.isFile) {
        //     return []
        // }
        return store.state.publicStore.tableRowData.powers || []
    })

    const isDisabledUploadButton = computed(() => {
        //上传只针对当前目录
        const isDisabled = !currentDirPermissions.value.includes(FilePower['UPLOAD'])
        // 根目录不允许上传文件
        return store.state.publicStore.currentDirId == '0' || isDisabled
    })

    const isDisabledDownloadButton = computed(() => {
        let isDisabled = false
        // 优先使用自己的权限码，如果没有配置，则使用父级权限码
        if (currentTableRowDataPermissions.value.length) {
            // 下载code为2
            isDisabled = !currentTableRowDataPermissions.value.includes(2)
        } else {
            isDisabled = !currentDirPermissions.value.includes(2)
        }
        // 选中数据才能下载
        const isSelectData = Boolean(
            store.state.publicStore.tableRowData.name && store.state.publicStore.tableRowData.id
        )
        return isDisabled || !isSelectData
    })

    // const downloadFileHandler = async () => {
    //     if (inElectron) {
    //         if (store.state.publicStore.tableRowData.isFile) {
    //             electronDownload(store.state.publicStore.tableRowData, router)
    //         } else {
    //             Message.error('客户端暂不支持文件夹直接下载，请先压缩再下载')
    //         }
    //     } else {
    //         const row = store.state.publicStore.tableRowData
    //         const params = JSON.stringify(row)
    //         const desktopUrl = getDesktopUrl(params)
    //         const isContinue = await preTransferHandler({
    //             files: row,
    //             threshold: transferThreshold,
    //             url: desktopUrl,
    //             transType: 'download',
    //         })
    //         if (isContinue) {
    //             const id = row.id
    //             const userId = store.state.publicStore.userId
    //             const origin = location.origin
    //             window.location.href = `${origin}/api/downloadFile?id=${id}&userId=${userId}`
    //         }
    //     }
    // }

    return {
        isDisabledUploadButton,
        isDisabledDownloadButton,
        // downloadFileHandler,
        // desktopUploadHandler,
    }
}
function judgePermission(files: IFileItem[]): boolean {
    // 判断是否有不可操作文件，并提示
    if (!isEmpty(files)) {
        const noPermissionFiles = files.map(item => item.name)
        const msg = `暂无以下文件操作权限--"${noPermissionFiles.join('"、"')}"`
        try {
            MessageBox.confirm(msg, '提示', {
                confirmButtonText: '确定',
                type: 'warning',
                showCancelButton: false,
            })
        } catch (error) {
            console.log(error)
        }
        return true
    }
    return false
}
function mainTableOperations(
    store: Store<any>,
    router: VueRouter,
    $$Vue: Vue,
    fromBread: Ref<boolean>,
    iconType: Ref<string>,
    datalist: Ref<IFileItem[]>,
    dataCurrent: number | null
) {
    const manageTopIds = computed(() => store.state.ManageTopIds)
    const tableRef = ref<Table>(void null)
    const newFileRef = ref<Input>(void null)
    const newGirdFileRef = ref<Input>(void null)
    const newDirName = computed({
        get: () => store.state.publicStore.newDirName,
        set: val => {
            store.commit('publicStore/SET_NEW_DIR_NAME', val)
        },
    })
    const dataType = ref<'multi' | 'single'>('single')
    const contextmenu = reactive({
        show: false,
        position: {
            x: 0,
            y: 0,
        },
    })
    const imgInfo = ref<IFileItem>({})
    const currentImgIndex = ref(0)
    const imgPreviewRef = ref<ImgPreviewType>(void null)
    const isShowImgPreview = ref(false)
    const isShowRightMenu = computed(() => store.state.publicStore.isShowRightMenu)
    const selectFiles = ref<IFileItem[]>([])
    const noCompressPowerFiles = ref<IFileItem[]>([])
    const noCopyPowerFiles = ref<IFileItem[]>([])
    const noDownloadPowerFiles = ref<IFileItem[]>([])
    const noRemovePowerFiles = ref<IFileItem[]>([])
    const hasSuperAdmin = computed(() => store.state.hasSuperAdmin)
    const handleWheel = e => {
        if (!isShowRightMenu.value) return
        e.preventDefault()
    }
    const handleUpDown = e => {
        if (!isShowRightMenu.value) return
        if (e.key == 'ArrowDown' || e.key == 'ArrowUp') {
            e.preventDefault()
        }
    }
    watch(
        () => isShowRightMenu.value,
        isShow => {
            if (isShow) {
                dataType.value = 'single'
            }
            contextmenu.show = isShow as any
        }
    )
    const tableData = ref<IFileItem[]>([])
    const imgData = computed(() => {
        if (iconType.value === 'line') {
            if (!tableData.value) return []
            return tableData.value.filter((file: IFileItem) => {
                return isImage(file.name as string)
            })
        } else {
            if (!datalist.value) return []
            return datalist.value.filter((file: IFileItem) => {
                return isImage(file.name as string)
            })
        }
    })
    // 预加载图片
    watch(
        () => imgData.value,
        () => {
            imgData.value.forEach(item => {
                const img = new Image()
                img.src = `/api/downloadFile?id=${item.id}`
            })
        },
        {
            lazy: true,
        }
    )
    const toNextLevel = async (row: IFileItem) => {
        // 进入下一级时，清除查询名称
        store.commit('publicStore/SET_QUERY_FORM_FILENAME', '')
        store.commit('publicStore/SET_CURRENT_SORT_NAMES')
        store.commit('publicStore/SET_CURRENT_SORT_TREND')
        store.commit('publicStore/SET_CURRENT_DIR_ID', row.id)
        store.commit('publicStore/UPDATE_TABLE_DATA_CACHE')
        const routePath = $$Vue.$route.path
        const toRoutePath = (routePath + '/' + row.name).replace(/\/\//g, '/')
        const isChangeRoute = await store.dispatch('publicStore/getTableData', {
            updataType: 'init',
        })
        fromBread.value = true
        router.push({ path: '/', query: { id: row.id } })
    }
    const getImgIndex = () => {
        return imgData.value.findIndex(file => file.id === imgInfo.value.id)
    }

    const viewImg = async (row: IFileItem) => {
        if (isImage(row.name as string)) {
            isShowImgPreview.value = true
            imgInfo.value = row
            currentImgIndex.value = getImgIndex()
            imgPreviewRef.value.resize(imgInfo.value)
        }
    }
    const createNewDir = () => {
        // 组件没更新，拿不到组件实例，root.$nextTick函数不知道3.0会不会有，所以先用setTimeout代替

        let flag = false

        if (iconType.value === 'line') {
            tableData.value.forEach(item => {
                if (item.id === 'createNewDir') {
                    flag = true
                }
            })
            if (!flag) {
                let options = {
                    id: 'createNewDir',
                    name: '新建文件夹',
                    isFile: false,
                    createTime: '',
                    size: '-',
                    createUser: '-',
                }
                tableData.value.unshift(options)
                setTimeout(() => {
                    newFileRef.value.select()
                }, 0)
            }
        } else {
            datalist.value.forEach(item => {
                if (item.id === 'createNewDir') {
                    flag = true
                }
            })
            if (!flag) {
                let options = {
                    id: 'createNewDir',
                    name: '新建文件夹',
                    isFile: false,
                    createTime: '',
                    size: '-',
                    createUser: '-',
                }
                datalist.value.unshift(options)
                setTimeout(() => {
                    if (newGirdFileRef.value) {
                        newGirdFileRef.value[0].focus()
                        newGirdFileRef.value[0].select()
                    }
                }, 0)
            }
        }
    }

    const postNewDir = async events => {
        // 避免图标模式下失焦和回车重复触发事件
        if (events.key === 'Enter' && iconType.value !== 'line') {
            events.target.blur()
            return
        }
        const name = newDirName.value as any
        const reg = /^[\(\)0-9a-zA-Z\u4e00-\u9fa5_（）-]+$/
        if (!reg.test(name)) {
            Message.error('名称只能包含数字字母汉字、下划线横线和括号')
            return
        }
        const postData = {
            parentId: store.state.publicStore.currentDirId,
            name,
        }
        if (iconType.value !== 'line') {
            newGirdFileRef.value[0].blur()
        }
        const res = await mkdir(postData)
        if (res && res.code === 0) {
            Message.success(res.desc)
        } else {
            Message.error(res.desc)
        }
        store.commit('publicStore/SET_NEW_DIR_NAME', '新建文件夹')
        store.dispatch('publicStore/getTableData')
        store.commit('publicStore/SET_IS_OPERATE', true)
    }

    const rowClick = (row: IFileItem, old) => {
        if (row && row.id !== 'createNewDir') {
            store.commit('publicStore/SET_CURRENT_TABLE_ROW_DATA', row)
        }
    }
    const rowDbClick = (row: IFileItem) => {
        if (!row.isFile) {
            // if((!row.powers || !row.powers.includes(FilePower['PREVIEW'])) && !findIsManager(manageTopIds.value as string[], row.id)) {
            //     Message.error('暂无可见权限')
            //     return
            // }
            toNextLevel(row)
        } else {
            viewImg(row)
        }
    }
    // 当前目录的权限
    const currentDirPermissions = computed(() => store.state.publicStore.powers || [])

    const HandleSelectTableChange = val => {
        if (val && val.length) {
            selectFiles.value = val.filter(item => item.id !== 'createNewDir')
        } else {
            selectFiles.value = []
        }
    }

    const isDisabledCreateNewDirButton = computed(() => {
        return !currentDirPermissions.value.includes(FilePermission.MKDIR)
    })

    const isShowDownloadIcon = (item: IFileItem) => {
        const itemPermissions = item.powers || []
        let isShow = false
        if (itemPermissions.length) {
            isShow = itemPermissions.includes(FilePermission.DOWNLOAD)
        } else {
            isShow = currentDirPermissions.value.includes(FilePermission.DOWNLOAD)
        }
        return isShow
    }

    //批量下载 压缩 复制 删除
    const isDisabledCompress = computed(() => {
        if (!selectFiles.value.length) {
            return false
        }
        noCompressPowerFiles.value = selectFiles.value.filter(item => {
            // 非管理员且不包含压缩权限,或者为根目录
            return (
                (item.level === 1 && !item.isFile) ||
                (!findIsManager(manageTopIds.value as string[], item.id) &&
                    item.powers &&
                    !item.powers.includes(FilePower['UNZIP_COMPRESS']))
            )
        })
        return noCompressPowerFiles.value.length === selectFiles.value.length
    })
    const isDisabledCopy = computed(() => {
        if (!selectFiles.value.length) {
            return false
        }
        noCopyPowerFiles.value = selectFiles.value.filter(item => {
            // 非管理员且不包含复制权限,或者为根目录
            return (
                (item.level === 1 && !item.isFile) ||
                (!findIsManager(manageTopIds.value as string[], item.id) &&
                    item.powers &&
                    !item.powers.includes(FilePower['MOVE_COPY']))
            )
        })
        return noCopyPowerFiles.value.length === selectFiles.value.length
    })
    const isDisabledDownload = computed(() => {
        if (!selectFiles.value.length) {
            return false
        }
        noDownloadPowerFiles.value = selectFiles.value.filter(item => {
            // 非管理员且不包含下载权限
            return (
                !findIsManager(manageTopIds.value as string[], item.id) &&
                item.powers &&
                !item.powers.includes(FilePower['DOWNLOAD'])
            )
        })
        return noDownloadPowerFiles.value.length === selectFiles.value.length
    })
    const isDisabledRemoveFiles = computed(() => {
        if (!selectFiles.value.length) {
            return false
        }
        // 遍历判断文件对应角色和权限，包含对应操作权限则返回true。记录无权限对应的文件
        noRemovePowerFiles.value = selectFiles.value.filter(item => {
            // 非管理员且不包含删除权限,或者为根目录且不为超管
            return (
                (item.level === 1 && !item.isFile && !hasSuperAdmin.value) ||
                (!findIsManager(manageTopIds.value as string[], item.id) &&
                    item.powers &&
                    !item.powers.includes(FilePower['DELETE']))
            )
        })
        return noRemovePowerFiles.value.length === selectFiles.value.length
    })

    const downloadFilesHandler = async () => {
        //批量下载权限判断
        const downloadSelectFiles = ref<IFileItem[]>([])
        downloadSelectFiles.value = selectFiles.value

        if (judgePermission(noDownloadPowerFiles.value)) {
            return
        }
        const downloadFn = async id => {
            const res = await checkBeforeDownload(id)
            if (res.code === 0 && res.data) {
                const link = document.createElement('a')
                const origin = location.origin
                link.download = ''
                link.target = '_blank'
                link.href = `${origin}/api/downloadAfterCheck?keyword=${res.data}`
                link.click()
            }
        }
        if (isElectron()) {
            const canDownloadFiles = downloadSelectFiles.value.every(item => {
                return !!item.isFile
            })
            if (!canDownloadFiles) {
                Message.error('您的选项中包含文件夹，不能执行下载操作，请取消文件夹选项后进行下载')
                return
            }
            const files = downloadSelectFiles.value.map(item => {
                return {
                    id: item.id,
                    identifier: item.identifier,
                    name: item.name,
                    size: item.size,
                    type: item.type,
                    chunkNum: item.chunkNum,
                }
            })
            const res = await (window as any).Ait.fileSystem.addDownloadFiles(files)
            if (res && res.data) {
                Message.success('开始下载，请前往下载中列表查看')
                // router.push("/transferList/download");
            } else {
                Message.error('下载出错')
            }
        } else {
            if (downloadSelectFiles.value.length > 10) {
                Message.error('下载操作最多支持10个文件（夹），请去除多余文件（夹）后进行操作')
                return
            }
            const files = downloadSelectFiles.value.map(item => {
                return {
                    size: Number(item.size),
                }
            })
            const isContinue = await preTransferHandler({
                files,
                threshold: transferThreshold,
                transType: 'download',
            })
            if (isContinue) {
                downloadSelectFiles.value.forEach(async file => {
                    const fileId = file.id
                    downloadFn(fileId)
                })
            }
        }
    }
    // 批量压缩
    const gZipFilesHandler = async () => {
        if (judgePermission(noCompressPowerFiles.value)) {
            return
        }
        await compressPrompt(selectFiles.value, store)
    }
    const multiCopy = () => {
        if (judgePermission(noCopyPowerFiles.value)) {
            return
        }
        dataType.value = 'multi'
        store.commit('publicStore/SET_COPYMOVE_BOX', 'copy')
        store.commit('publicStore/SET_COPYMOVE_BOX_SHOW', true)
    }
    const removeFilesHandler = async () => {
        const ids = selectFiles.value.map(item => item.id)
        if (judgePermission(noRemovePowerFiles.value)) {
            return
        }
        const msg = `确认删除选择的文件（夹）？（删除文件夹会删除该文件夹下所有内容，请谨慎操作！）`
        try {
            await MessageBox.confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
            const res = await batchDeleteFileOrDir(ids as string[])
            if (res && res.code === 0) {
                Message.success(res.desc || '删除成功')
                store.dispatch('publicStore/getTableData')
            } else {
                Message.error(res.desc || '删除失败')
            }
        } catch (error) {
            console.log(error)
        }
    }
    const rightMenuDataSize = ref<number>(0)

    const rowContextMenu = (row: IFileItem, column: any, event: MouseEvent) => {
        event.preventDefault()
        if (column) {
            tableRef.value.setCurrentRow(row)
        } else {
            selectFiles.value = [row]
            if (row && row.id !== 'createNewDir') {
                store.commit('publicStore/SET_CURRENT_TABLE_ROW_DATA', row)
            }
        }
        store.commit('publicStore/SET_RIGHT_MENU_IS_SHOW', true)
        rightMenuDataSize.value = +row.size
        // 计算坐标是否超出屏幕所在位置
        const windowHeight = document.body.clientHeight
        const windowWidth = document.body.clientWidth
        const clickClientY = event.clientY
        const clickClientX = event.clientX
        // 确保右键菜单底部不超出可视区域
        const offsetY = windowHeight - clickClientY > 440 ? 0 : 440 - (windowHeight - clickClientY)
        const offsetX = windowWidth - clickClientX > 140 ? 0 : 140 - (windowWidth - clickClientX)
        contextmenu.position.x = clickClientX - offsetX
        contextmenu.position.y = clickClientY - offsetY
    }

    const preImg = async () => {
        const index = getImgIndex()
        if (index > 0) {
            currentImgIndex.value = index - 1
            imgInfo.value = imgData.value[currentImgIndex.value]
        } else {
            Message.info('当前已是第一张图片')
        }
    }
    const nextImg = async (row: IFileItem) => {
        const index = getImgIndex()
        if (index >= 0 && index < imgData.value.length - 1) {
            currentImgIndex.value = index + 1
            imgInfo.value = imgData.value[currentImgIndex.value]
        } else {
            Message.info('当前已是最后一张图片')
        }
    }

    const closeCanvas = async () => {
        isShowImgPreview.value = false
    }

    const onMoveSuccess = async () => {
        store.commit('publicStore/SET_COPYMOVE_BOX_SHOW', false)
        imgPreviewRef.value.closeFildTree()
        await store.dispatch('publicStore/getTableData')
        if (iconType.value !== 'line') {
            // 处理图标模式下图片移动
            const params = {
                current: 1,
                size: dataCurrent ? dataCurrent * 100 : 100,
            }
            await store.dispatch('publicStore/getDataList', params)
        }
        if (imgData.value.length === 0) {
            closeCanvas()
            return false
        }
        if (currentImgIndex.value >= imgData.value.length - 1) {
            imgInfo.value = imgData.value[imgData.value.length - 1]
        } else if (currentImgIndex.value >= 0) {
            imgInfo.value = imgData.value[currentImgIndex.value]
        } else {
            imgInfo.value = imgData.value[0]
        }
    }

    const sortChange = async ({ order, prop }) => {
        if (order === 'ascending') {
            store.commit('publicStore/SET_CURRENT_SORT_NAMES', prop)
            store.commit('publicStore/SET_CURRENT_SORT_TREND', 1)
        } else if (order === 'descending') {
            store.commit('publicStore/SET_CURRENT_SORT_NAMES', prop)
            store.commit('publicStore/SET_CURRENT_SORT_TREND', -1)
        } else {
            store.commit('publicStore/SET_CURRENT_SORT_NAMES')
            store.commit('publicStore/SET_CURRENT_SORT_TREND')
        }

        await store.dispatch('publicStore/getTableData')
    }
    onMounted(() => {
        // 阻止页面滚动
        window.addEventListener('wheel', handleWheel, { passive: false })
        window.addEventListener('keydown', handleUpDown, { passive: false })
    })
    onBeforeUnmount(() => {
        window.removeEventListener('wheel', handleWheel)
        window.removeEventListener('keydown', handleUpDown)
    })

    return {
        tableRef,
        contextmenu,
        tableData,
        rowClick,
        rowDbClick,
        selectFiles,
        HandleSelectTableChange,
        isDisabledCreateNewDirButton,
        isShowDownloadIcon,
        isDisabledDownload,
        isDisabledCopy,
        isDisabledCompress,
        downloadFilesHandler,
        gZipFilesHandler,
        multiCopy,
        isDisabledRemoveFiles,
        removeFilesHandler,
        rowContextMenu,
        isShowImgPreview,
        imgInfo,
        imgData,
        toNextLevel,
        imgPreviewRef,
        currentImgIndex,
        viewImg,
        preImg,
        nextImg,
        onMoveSuccess,
        closeCanvas,
        newFileRef,
        newGirdFileRef,
        newDirName,
        createNewDir,
        postNewDir,
        dataType,
        sortChange,
        rightMenuDataSize,
        datalist,
    }
}

function usePage(store: Store<any>) {
    const conditions: UnwrapRef<IPageNation> = reactive({
        pageNum: ref(1),
        pageSize: ref(10),
        total: ref(0),
    })
    const storeCurrentPage = computed(() => store.state.publicStore.currentPage)
    const storePageSize = computed(() => store.state.publicStore.pageSize)
    const storeDataTotalNum = computed(() => store.state.publicStore.dataTotalNum)
    watch(
        [() => storeCurrentPage.value, () => storePageSize.value],
        async ([pageNum, pageSize]) => {
            conditions.pageNum = pageNum as any
            conditions.pageSize = pageSize as any
            await store.dispatch('publicStore/getTableData')
        },
        {
            lazy: true,
        }
    )
    // 单独watch totalnum,避免请求两次数据
    watch(
        () => storeDataTotalNum.value,
        total => {
            conditions.total = total as any
        }
    )

    const changePageSize = (pageSize: number) => {
        store.commit('publicStore/SET_PAGE_SIZE', pageSize)
        store.commit('publicStore/SET_CURRENT_PAGE', 1)

        // 切换页码时不会触发document的click事件，手动关闭右键菜单
        store.commit('publicStore/SET_RIGHT_MENU_IS_SHOW', false)
    }
    const setCurrentPage = (currentPage: number) => {
        store.commit('publicStore/SET_CURRENT_PAGE', currentPage)
    }
    onMounted(() => {
        setCurrentPage(1)
        conditions.pageNum = +storeCurrentPage.value || 1
        conditions.pageSize = +storePageSize.value || 10
    })

    return {
        conditions,
        changePageSize,
        setCurrentPage,
    }
}

function changeIconModel(
    store: Store<any>,
    datalist: Ref<IFileItem[]>,
    selectFiles: Ref<IFileItem[]>,
    iconType: Ref<string>,
    showBox: Readonly<Ref<Readonly<any>>>,
    tableRef: Ref<any>
) {
    const contentRef: Ref<any> = ref(null)
    // const checkFilelist: Ref<IFileItem[]> = ref([])
    const clickCheckFile: Ref<IFileItem> = ref({})

    const handleIconSize = (item: string) => {
        iconType.value = item
        if (item === 'line') {
            selectFiles.value = []
        }
    }
    watch(
        () => datalist.value,
        () => {
            selectFiles.value = []
        }
    )
    const setMargin = (index: number) => {
        if (iconType.value !== 'grid-large') {
            return ''
        }
        const width = contentRef.value.offsetWidth - 60
        const itemLength = Math.floor(width / 280)
        const marginItem = Math.floor((width - 280 * itemLength) / ((itemLength - 1) * 2))
        let style = `margin-left:${marginItem}px;margin-right:${marginItem}px`
        if (!index || !(index % itemLength)) {
            style = `margin-left:0;margin-right:${marginItem}px`
        } else if ((index + 1) % itemLength === 0) {
            style = `margin-left:${marginItem}px;margin-right:0`
        }
        return style
    }
    const senseIsCheck = (id: string) => {
        let isCheck = false
        selectFiles.value.map(val => {
            if (val.id === id) {
                isCheck = true
            }
        })
        return isCheck
    }

    // 点击选中
    const checkGridFile = (event, item: IFileItem, index: number) => {
        event.preventDefault()
        if (event.ctrlKey) {
            if (senseIsCheck(item.id as string)) {
                selectFiles.value = selectFiles.value.filter(val => {
                    if (val.id !== item.id) {
                        return true
                    }
                })
            } else {
                selectFiles.value.push(item)
                clickCheckFile.value = item
            }
        } else if (event.shiftKey) {
            selectFiles.value = []
            let clickItemIndex = (datalist.value || []).findIndex(value => value.id === item.id)
            let lastClickIndex = (datalist.value || []).findIndex(value => value.id === clickCheckFile.value.id)
            let minIndex = 0,
                maxIndex = 0
            clickItemIndex = clickItemIndex === -1 ? 0 : clickItemIndex
            lastClickIndex = lastClickIndex === -1 ? 0 : lastClickIndex
            minIndex = clickItemIndex < lastClickIndex ? clickItemIndex : lastClickIndex
            maxIndex = clickItemIndex >= lastClickIndex ? clickItemIndex : lastClickIndex
            datalist.value.forEach((value, index) => {
                if (minIndex <= index && index < maxIndex + 1) {
                    selectFiles.value.push(value)
                }
            })
        } else {
            selectFiles.value = [item]
            clickCheckFile.value = item
        }
        store.commit('publicStore/SET_RIGHT_MENU_IS_SHOW', false)
    }
    const clickMainArea = () => {
        if (iconType.value !== 'line' && !store.state.publicStore.showCopyMoveBox) selectFiles.value = []
    }
    const checkAll = event => {
        if (event.code === 'KeyA' && event.ctrlKey) {
            event.preventDefault()
            selectFiles.value = datalist.value
        }
    }
    onMounted(() => {
        document.addEventListener('keydown', checkAll)
    })
    onUnmounted(() => {
        document.removeEventListener('keydown', checkAll)
    })

    return {
        handleIconSize,
        setMargin,
        contentRef,
        checkGridFile,
        senseIsCheck,
        clickCheckFile,
        clickMainArea,
        checkAll,
    }
}

export default createComponent({
    components: {
        ImgPreview,
        RightContextMenu,
        PermissionDialog,
        CopyMoveBox,
        SliceUploader,
        UnZipList,
        ZipList,
        DuplicateNameConfirm,
        permissionEdit,
        permissionGrant,
    },
    setup(props, setupContext) {
        const store = useStore()
        const router = useRouter()
        const render = ref<boolean>(true)
        const fromBread = ref<boolean>(true) // 区分go\back 和页面操作路由
        const iconType: Ref<string> = ref('line')
        const datalist = ref<IFileItem[]>([])
        const dataCurrent = ref<number>(null)
        const Uploader = ref(null)
        const viewPermission = ref<boolean>(false)
        const grantPermission = ref<boolean>(false)
        const isShowPermissionDialog = computed(() => store.state.publicStore.isShowPermssionDialog)

        const { breadData, clickBread } = useBread(store, router, fromBread, setupContext)

        const { queryFormFileName, queryFormFileTime, onSearchSubmit } = searchFrom(store)
        const useHandleCheckFile = handleCheckFile(setupContext)

        const pageId = ref('')
        const closeMove = () => {
            store.commit('publicStore/SET_COPYMOVE_BOX_SHOW', false)
        }
        const showBox = computed(() => {
            return store.state.publicStore.showCopyMoveBox
        })
        const selectedFile = computed(() => store.state.publicStore.tableRowData)
        const useOperationButtons = operationButtons(store, router)
        const useMainTableOperations = mainTableOperations(
            store,
            router,
            setupContext.root,
            fromBread,
            iconType,
            datalist,
            dataCurrent.value
        )

        const { tableData, selectFiles, rowContextMenu, tableRef } = useMainTableOperations
        const changeIconModels = changeIconModel(store, datalist, selectFiles, iconType, showBox, tableRef)

        const dragfunction = handleDragDrop(
            store,
            useOperationButtons.isDisabledDownloadButton,
            useOperationButtons.isDisabledUploadButton,
            Uploader,
            router,
            fromBread,
            selectFiles,
            setupContext,
            useHandleCheckFile
        )

        const { conditions, changePageSize, setCurrentPage } = usePage(store)

        // 取store里面的数据显示列表
        watch(
            [() => store.state.publicStore.showCacheData],
            () => {
                const currentFileData = store.state.publicStore.fileListdata[store.state.publicStore.currentDirId]
                if (currentFileData) {
                    tableData.value = currentFileData.data as IFileItem[]
                    store.commit('publicStore/SET_DATA_TOTAL_NUM', currentFileData.total)
                    const sourcePath = [...(currentFileData.ancestors || [])].reverse()
                    const powers = currentFileData.powers || []
                    setBreadData(sourcePath, store)
                    store.commit('publicStore/SET_POWERS', powers)
                    // 重新加载数据后，清除store中保存的tableRowData,避免页面没有选中数据，但实际还有数据可以操作
                    store.commit('publicStore/SET_CURRENT_TABLE_ROW_DATA', {})
                } else {
                    tableData.value = []
                }
                try {
                    const pageInfoStr = sessionStorage.getItem('pageInfos'),
                        pageId: string = setupContext.root.$route.query.id + ''
                    if (pageInfoStr) {
                        let pageInfo = JSON.parse(pageInfoStr).filter(val => {
                            return val.id === pageId
                        })
                        conditions.pageNum = pageInfo[0].pageNum || 1
                        conditions.pageSize = pageInfo[0].pageSize || 10
                    }
                } catch (err) {
                    //
                }
            },
            {
                lazy: true,
            }
        )
        watch(
            () => store.state.publicStore.getDataListType,
            val => {
                datalist.value = store.state.publicStore.dataList
                dataCurrent.value = store.state.publicStore.dataCurrent
            }
        )
        const disableSearchTemplate = ref<boolean>(false)
        watch(
            () => store.state.publicStore.disableGetDataList,
            newVal => {
                disableSearchTemplate.value = newVal
            },
            {
                lazy: true,
            }
        )
        watch(
            () => store.state.publicStore.dataCurrent,
            () => {
                if (store.state.publicStore.dataCurrent === 1) {
                    const el = document.querySelector('.flex-content') as Element
                    el && (el.scrollTop = 0)
                }
            }
        )
        const getDataList = async () => {
            const params = {
                current: dataCurrent.value,
            }
            await store.dispatch('publicStore/getDataList', params)
        }
        watch(
            () => store.state.publicStore.currentDirId,
            () => {
                tableRef.value && tableRef.value.clearSort()
            }
        )

        watch(
            () => setupContext.root.$route.fullPath,
            async (newv, old) => {
                if (!tableData.value.length) {
                    fromBread.value = false
                }
                pageId.value = (setupContext.root.$route.query.id as string) || '0'
                if (fromBread.value === false) {
                    const routeDirId = setupContext.root.$route.query.id
                    const queryDirId = routeDirId ? routeDirId : 0
                    store.commit('publicStore/SET_CURRENT_DIR_ID', queryDirId)
                    await store.dispatch('publicStore/getTableData', {
                        updataType: 'init',
                    })
                } else {
                    fromBread.value = false
                }
            }
        )

        watch(
            () => setupContext.root.$store.state.publicStore.isViewPermission,
            value => {
                viewPermission.value = value
            }
        )
        watch(
            () => setupContext.root.$store.state.publicStore.isGrantPermission,
            value => {
                grantPermission.value = value
            }
        )

        const handleDownload = async row => {
            if (!row.id || row.id === 'createNewDir') {
                Message.error('缺少文件（夹）Id')
                return
            }
            const id = row.id
            const downloadFn = async () => {
                const res = await checkBeforeDownload(id)
                if (res.code === 0 && res.data) {
                    const link = document.createElement('a')
                    const origin = location.origin
                    const userId = store.state.publicStore.userId
                    link.href = `${origin}/api/downloadAfterCheck?keyword=${res.data}&userId=${userId}`
                    link.click()
                }
            }
            if (isElectron()) {
                console.log('发送请求到客户端')
                const file = row
                if (file.isFile) {
                    electronDownload(file, setupContext.root.$router)
                } else {
                    Message.error('客户端暂不支持文件夹直接下载，请先压缩再下载')
                }
            } else {
                const params = JSON.stringify(row)
                const desktopUrl = getDesktopUrl(params)
                const isContinue = await preTransferHandler({
                    files: row,
                    threshold: transferThreshold,
                    url: desktopUrl,
                    transType: 'download',
                })
                if (isContinue) {
                    downloadFn()
                }
            }
        }

        const showMore = (row, column, e) => {
            e.stopPropagation()
            rowContextMenu(row, column, e)
        }

        // 离开页面时存储本次搜索条件
        const setCurrentPageInfo = () => {
            const obj = {
                id: pageId.value,
                queryFormFileName: queryFormFileName.value,
                queryFormFileTime: queryFormFileTime.value,
                conditions: conditions,
            }
            sessionStorage.setItem('currentPage', JSON.stringify(obj))
        }

        // 获取上次查询条件
        const getCurrentPageInfo = () => {
            const currentPageInfo = JSON.parse(sessionStorage.getItem('currentPage') as string)
            if (pageId.value === currentPageInfo.id) {
                if (currentPageInfo.queryFormFileName || currentPageInfo.queryFormFileTime) {
                    store.commit('publicStore/SET_QUERY_FORM_FILENAME', currentPageInfo.queryFormFileName)
                    store.commit('publicStore/SET_QUERY_FORM_CREATETIME', currentPageInfo.queryFormFileTime)
                } else {
                    store.commit('publicStore/SET_CURRENT_PAGE', currentPageInfo.conditions.pageNum)
                    store.commit('publicStore/SET_PAGE_SIZE', currentPageInfo.conditions.pageSize)
                }
            }
            sessionStorage.removeItem('currentPage')
        }
        const reload = () => {
            // 重新渲染
            render.value = false
            setupContext.root.$nextTick(() => {
                render.value = true
            })
        }
        onMounted(async () => {
            // 页面注册点击隐藏右键菜单
            document.addEventListener('click', e => {
                store.commit('publicStore/SET_RIGHT_MENU_IS_SHOW', false)
            })
            const routeDirId = setupContext.root.$route.query.id
            const queryDirId = routeDirId ? routeDirId : 0
            store.commit('publicStore/SET_CURRENT_SORT_NAMES')
            store.commit('publicStore/SET_CURRENT_SORT_TREND')
            store.commit('publicStore/SET_CURRENT_DIR_ID', queryDirId)
            fromBread.value = true
            if (sessionStorage.getItem('currentPage')) {
                getCurrentPageInfo()
            }
            await store.dispatch('publicStore/getTableData')
            window.addEventListener('resize', reload)
        })

        onBeforeUnmount(() => {
            // 每次清除缓存

            console.log('clear storage')
            // localStorage.clear();
            setCurrentPageInfo()
            window.removeEventListener('resize', reload)
        })

        const zipDetails = useZipDetails(store)

        // 右下角的操作
        const handleOpenTaskDialog = () => {
            if (inElectron) {
                const currentDirId = store.state.publicStore.currentDirId
                desktopUploadHandler(currentDirId)
            } else {
                store.commit('operateStore/SET_OPENFILEPATH_DATA')
            }
        }
        return {
            isElectron,
            fromBread,
            selectedFile,
            closeMove,
            showBox,
            breadData,
            clickBread,
            queryFormFileName,
            queryFormFileTime,
            onSearchSubmit,
            reload,
            render,
            ...useOperationButtons,
            isShowPermissionDialog,
            ...useHandleCheckFile,
            conditions,
            changePageSize,
            setCurrentPage,
            getFileIcon,
            formatFileSize,
            moment,
            iconType,
            ...dragfunction,
            DragState,
            handleDownload,
            showMore,
            ...zipDetails,
            ...useMainTableOperations,
            ...changeIconModels,
            datalist,
            getDataList,
            disableSearchTemplate,
            Uploader,
            handleOpenTaskDialog,
            viewPermission,
            grantPermission,
        }
    },
})
